import { firestore } from "../components/firebase.config";
import { collection, getDocs, addDoc, query, where, updateDoc, doc } from "firebase/firestore";
import { v4 as uuidv4 } from 'uuid';

export const fetchDataFromFirestore = async () => {
    try {
        const querySnapshot = await getDocs(collection(firestore, "appoinement"));
        const data = querySnapshot.docs.map((doc) => doc.data());
        return data;
    } catch (error) {
        console.error("Error fetching documents: ", error);
        throw error;
    }
};

// User Management Functions
export const getUserProfileByEmail = async (email) => {
    try {
        const userProfileRef = collection(firestore, 'UserProfileMaster');
        const q = query(userProfileRef, where('email', '==', email));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
            const userProfile = querySnapshot.docs[0].data();
            return {
                ...userProfile,
                isAppAdmin: userProfile.role === 'AppAdmin',
                isAppUser: userProfile.role === 'AppUser'
            };
        }
        return null;
    } catch (error) {
        console.error("Error fetching user profile:", error);
        throw error;
    }
};

export const addUserToFirestore = async (userData) => {
    try {
        const userProfileRef = collection(firestore, 'UserProfileMaster');
        const userDataWithDefaults = {
            ...userData,
            role: userData.role || 'AppUser',
            uid: uuidv4(),
            isActive: true,
            isVerified: true,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
        };
        
        const docRef = await addDoc(userProfileRef, userDataWithDefaults);
        return { id: docRef.id, ...userDataWithDefaults };
    } catch (error) {
        console.error("Error adding user:", error);
        throw error;
    }
};

export const updateUserRole = async (email, newRole) => {
    try {
        const userProfileRef = collection(firestore, 'UserProfileMaster');
        const q = query(userProfileRef, where('email', '==', email));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
            const docRef = doc(firestore, 'UserProfileMaster', querySnapshot.docs[0].id);
            await updateDoc(docRef, {
                role: newRole,
                updatedAt: new Date().toISOString()
            });
            return true;
        }
        return false;
    } catch (error) {
        console.error("Error updating user role:", error);
        throw error;
    }
};
